export default {
  filters: {
    recommend: '推薦',
    favorites: '收藏',
    recents: '最近',
  },
  placeholder: {
    pending: '接口待接入，敬請期待',
  },
  empty: {
    games: '暫無遊戲',
    gamesHint: '換個分類看看',
    favorites: '還沒有收藏',
    favoritesHint: '點遊戲卡片右上角星星收藏',
    recents: '暫無最近遊玩',
    recentsHint: '玩過的遊戲會出現在這裡',
  },
  loadMore: {
    armed: '繼續上劃，加載更多…',
    loading: '加載中…',
    end: '-已經到底啦-',
  },
  search: {
    searchGames: '搜遊戲',
    placeholder: '搜索遊戲/廠商',
    trending: '熱門搜索',
    result: '找到 {count} 個結果',
    searching: '搜索中…',
    empty: '沒有找到相關遊戲',
    emptyHint: '換個關鍵詞試試吧',
    clear: '清空',
    vendor: '廠商',
  },
  jackpotTicker: {
    title: '實時爆獎',
    live: 'LIVE',
    subtitle: '恭喜以下玩家喜提大獎',
    empty: '暫無爆獎信息，快來成為下一個大贏家！',
  },
  play: {
    loading: '遊戲加載中...',
    transferTitle: '額度轉換成功',
    copyTitle: '複製成功',
    balanceLabel: '當前「{venue}」餘額',
    /** USDT 站 + CNY 映射場館：金額下方計價提示 */
    mappedRatePrefix: '本場館內計價',
    mappedRateEq: '1 ¥ = 1 {code}',
    mappedRateSuffix: '，進出等值可逆',
    transferDesc: '如需充值，可返回 BetCorgi 主界面，或點右上角懸浮按鈕直接充值',
    copyDesc: '此處充值，可返回 BetCorgi 主界面，或點右上角懸浮按鈕直接充值',
    start: '開始遊戲',
    menu: {
      exit: '退出',
      deposit: '訂金',
      transfer: '轉移',
      support: '客服',
      expand: '展開菜單',
      collapse: '收起菜單',
    },
  },
}
